var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(-376 1708)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 72,
    height: 72,
    transform: "translate(376 -1708)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(375.118 -1707.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Tracking_outline_standby-3",
    "data-name": "ic/Tracking/outline/standby-3",
    transform: "translate(2.081 3.745)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30.24,
    cy: 30.24,
    r: 30.24,
    fill: "none",
    stroke: "#24272a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 3.128,
    cy: 3.128,
    r: 3.128,
    transform: "translate(27.111 27.111)",
    fill: "#f7e127",
    stroke: "#24272a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.256 6.256)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 23.983,
    cy: 23.983,
    r: 23.983,
    transform: "translate(0 0)",
    fill: "#f7e127",
    stroke: "#24272a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "power",
    transform: "translate(19.812 19.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.7,1.276A10.241,10.241,0,0,0,.635,12.7a10.467,10.467,0,0,0,19.585,0A10.241,10.241,0,0,0,17.155,1.276",
    transform: "translate(0 1.385)",
    fill: "none",
    stroke: "#24272a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Path-2",
    "data-name": "Path",
    y2: 10.646,
    transform: "translate(10.427)",
    fill: "none",
    stroke: "#24272a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 13.295,
    cy: 13.295,
    r: 13.295,
    transform: "translate(43.013 36.757)",
    fill: "#fff",
    stroke: "#24272a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M8.5,4.958v7.386l4.432,4.432",
    transform: "translate(47.808 37.707)",
    fill: "none",
    stroke: "#24272a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandby);
export default __webpack_public_path__ + "static/media/standby.8923ea5a194e117d97268d731af8da76.svg";
export { ForwardRef as ReactComponent };